module.exports = ".center-text {\n  text-align: center; }\n\n.dates-text {\n  padding-top: 0.4rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/statistics.component.scss
// module id = ./src/app/statistics/statistics.component.scss
// module chunks = main